import { syncWaitRoute } from '@jira/router-routes__sync-wait-routes/src/syncWaitRoute.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { syncWaitPageEntryPoint } from './ui/syncWaitPageEntryPoint.tsx';

const syncWaitEntryPoint = createPageEntryPoint({
	main: syncWaitPageEntryPoint,
});

export const syncWaitRouteEntry: Route = createEntry(syncWaitRoute, () => ({
	layout: chromelessLayout,
	entryPoint: () => syncWaitEntryPoint,
	bifrost: {
		bifrostGroup: 'shell-only',
		enabled: true,
	},
}));
